import { FormEvent, useState } from "react"
import { Link } from "react-router-dom"
import { requestPasswordReset } from "../lib/auth"
import { config } from "../lib/config"

export const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault()
    setError(null)
    setMessage(null)
    setLoading(true)
    try {
      const result = await requestPasswordReset(email.trim())
      setMessage(result.message)
    } catch (err) {
      setError(err instanceof Error ? err.message : "Não foi possível processar o pedido.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 shadow-sm"
      >
        <div className="mb-6 text-center">
          <Link to="/" className="inline-flex items-center gap-2" aria-label={`${config.appName} início`}>
            <img src="/assets/brand/logo-horizontal.svg" alt="" className="mx-auto h-9 w-auto" />
          </Link>
          <h1 className="mt-4 text-xl font-semibold text-slate-900">Esqueceu a senha?</h1>
          <p className="mt-2 text-sm text-slate-600">
            Informe o e-mail da sua conta. Enviaremos uma senha provisória; no primeiro acesso você definirá uma nova
            senha.
          </p>
        </div>

        <label className="block text-sm font-medium text-slate-700" htmlFor="email">
          E-mail
        </label>
        <input
          id="email"
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/30"
        />

        {error ? <p className="mt-3 text-sm text-red-600">{error}</p> : null}
        {message ? <p className="mt-3 text-sm text-green-700">{message}</p> : null}

        <button
          type="submit"
          disabled={loading}
          className="mt-6 w-full rounded-lg bg-brand-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-brand-700 disabled:opacity-60"
        >
          {loading ? "Enviando…" : "Enviar senha provisória"}
        </button>

        <p className="mt-4 text-center text-sm text-slate-600">
          <Link to="/login" className="font-medium text-brand-600 hover:underline">
            Voltar ao login
          </Link>
        </p>
      </form>
    </main>
  )
}
